var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"floor-preload"},[_c('div',{staticClass:"loading"},[_c('i',{staticClass:"el-icon-loading"}),_c('div',{staticClass:"loading-text"},[_vm._v("加载中")])])])
}]

export { render, staticRenderFns }